import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { Button, notification, Row, Col } from "antd";
import { createPaymentStatus } from "../../redux/services/apiService";
import queryString from "query-string";

let actionTypes = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILED",
};

const GenerateLink = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const { clientId = "makro-suite" } = queryString.parse(location.search);

  const openNotification = (type, message) => {
    notification[type]({
      message: "Payment Status",
      description: message,
      placement: "topRight",
    });
  };

  const handlePaymentStatus = async (status) => {
    try {
      const response = await createPaymentStatus(
        {
          payment_status: status,
          payment_amount: 1000,
          payment_id: `${orderId}_transaction_id`,
        },
        clientId,
        orderId,
        status === actionTypes.SUCCESS
          ? "paymentStatusTestSuccess"
          : "paymentStatusTestFailure"
      );

      if (response && response.status === 200) {
        if (status === actionTypes.SUCCESS) {
          openNotification("success", `Payment status sent: ${status}`);
        } else {
          openNotification("error", `Payment status sent: ${status}`);
        }
      } else {
        openNotification(
          "error",
          `Unexpected response: ${response.message || "Unknown error"}`
        );
      }
    } catch (error) {
      openNotification(
        "error",
        `Failed to send payment status: ${error.message || "Unknown error"}`
      );
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Payment Status</h1>
      <Row justify="center" gutter={16}>
        <Col>
          <Button
            type="primary"
            style={{ backgroundColor: "#28A745", borderColor: "#28A745" }}
            onClick={() => handlePaymentStatus(actionTypes.SUCCESS)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#218838")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#28A745")
            }
          >
            Success
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            danger
            style={{ backgroundColor: "#DC3545", borderColor: "#DC3545" }}
            onClick={() => handlePaymentStatus(actionTypes.FAILURE)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#C82333")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#DC3545")
            }
          >
            Failure
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default GenerateLink;
